import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	await import( "../scrollbar.min.js" );
	initCustomScrollbar( block );
};

themeUtils.loadBlock( initBlock, "content", ".section-content" );
